import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import { green700, grey200, red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import config from 'cfg';

import moment from 'moment';

import styled from 'styled-components';

import SMPostDialog from '../SMPostDialog';

import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconShare from 'material-ui/svg-icons/social/share';

import F1SMStream from '../streams/f1/F1SMStream';
import F1SessionSMStream from '../streams/f1/F1SessionSMStream';

class F1GPXSMBrowser extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.loadData();
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.params.gpId !== this.props.params.gpId) {
            this.forceUpdate(() => {
                this.loadData();
            });
        }
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    loadData = () => {
        let { gpId } = this.props.params;
        var user = this.context.user;
        if (!user || !user.client) return null;
        return RCore.promiseProps({
            gp: fetch(`${config.apis.ss2}/f1/gpx/${gpId}/info`).then(response => response.json())
        })
            .then(result => {
                this.setState({
                    ...result,
                    template: _.last(result.templates),
                    isLoading: false
                });
            })
            .catch(e => {
                this.setState({
                    error: e,
                    isLoading: false
                });
            });
    };

    render() {
        const user = this.context.user;
        let { gp } = this.state;
        if (!gp) return <div />;

        return (
            <div className="row">
                <div className="col-md-12">
                    <h1>{gp.name}</h1>
                    <table>
                        <tbody>
                            {gp.events.map(e => {
                                return (
                                    <tr key={'g' + e.eventId}>
                                        <td>{e.name}</td>
                                        <td>{e.statusFull}</td>
                                        <td>{moment(e.startDate).format('DD MMM, hh:mm')}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="col-md-12">
                    <F1SessionSMStream gpId={gp.id} type="race" />
                    <F1SessionSMStream gpId={gp.id} type="qual" />
                    <F1SessionSMStream gpId={gp.id} type="practice" />
                    <F1SMStream gpId={gp.id} year={gp.year} />
                </div>
            </div>
        );
    }
}

export default F1GPXSMBrowser;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/F1GPXSMBrowser.js
 **/